export default __webpack_public_path__ + "static/media/B_Adhesives_Screeds.fc0d5c09.jpg";